<template>
    <div class="h-full md:h-screen">
        <div class="flex flex-col md:flex-row items-center rounded bg-white p-4 mb-4 w-full">
            <div class="w-full md:w-4/12 mb-3 md:mb-0">
                <input
                    v-model="filters.filter_text"
                    type="text"
                    @keyup="searchChannels()"
                    placeholder="Search Assets, Tickets, Service Providers"
                    class="form-control min-width-200">
            </div>

            <div class="flex w-full md:w-3/12 items-center ml-0 md:ml-4 mr-0 md:mr-4 mb-3 md:mb-0">
                <label class="mr-2 whitespace-pre">Assigned To</label>
                <el-select v-model="filters.user_filter" multiple collapse-tags placeholder="Select User(s)">
                    <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.name | capitalize"
                        :value="user.id">
                    </el-option>
                </el-select>
            </div>

            <el-checkbox
                v-model="filters.only_new_messages"
                class="justify-start font-normal w-full md:w-2/12"
                @change="searchChannels()">
                Only Show Unread
            </el-checkbox>
        </div>

        <ul v-if="channels.length > 0" class="overflow-y-auto h-7/12" @scroll="handleScroll">
            <li v-for="(channel, index) in channels" :key="'channel-item-' + channel.id" class="shadow-sm rounded-b-lg" :class="index !== 0 ? 'mt-3' : ''">
                <messenger-channel-list-item :channel="channel" type="inbox" @show-channel="showChannel(channel)"></messenger-channel-list-item>
            </li>
        </ul>

        <div v-else-if="loadingChannelsList" class="p-12 text-lg font-medium flex justify-around items-center">
            Loading Channels
        </div>

        <div v-else class="p-12 text-lg font-medium flex justify-around items-center">
            {{ filters.only_new_messages ? "No Channels with Unread Messages" : "No Matching Channels To Show" }}
        </div>

        <channel-container-modal :show="showChannelModal">
            <div v-if="selectedChannel" class="flex flex-col items-stretch h-full">
                <button @click.prevent="closeChannel"
                        class="cursor-pointer p-2 font-bold bg-gray-700 text-white flex items-center">
                    <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                    </svg>
                    Back
                </button>
                <!-- The selectedChannel && showChannelModal properties are on the SelectChannel mixin-->
                <messenger-channel :channel="selectedChannel" :echo="echo" :show-share-existing-media-button="false"></messenger-channel>
            </div>
        </channel-container-modal>
    </div>
</template>

<script>
import MessengerListMixin from "../../mixins/messenger-list-mixin";
import ChannelContainerModal from "./ChannelContainerModal";

export default {
    name: "InboxChannelList",
    components: {ChannelContainerModal},
    mixins: [MessengerListMixin],
    data () {
        return {
            loading: true,
            users: [],
            infiniteHandlerUrl: "/messenger/channels/all"
        };
    },
    watch: {
        "filters.user_filter.length": function () {
            this.searchChannels();
        }
    },
    created () {
        this.getUsers();
    },
    mounted () {
        if (this.hasFeature("feat_service_provider_portals")) {
            this.searchChannels();
        }
    },
    methods: {
        getUsers () {
            this.loading = true;
            axios.get("/users", {
                "params": {
                    search_text: "",
                    per_page: 100,
                    status: "active",
                    user_type: "team_users"
                }
            })
            .then(response => {
                this.users = response.data.data;
                this.loading = false;
            }).catch((error) => {
                toastr.error(error.message);
                this.loading = false;
            });
        },
    }
};
</script>

<style scoped>

</style>
